import { Injectable } from '@angular/core';
import {Observable, Subject} from "rxjs";

@Injectable()
export class ResetSpecsService {

  private _resetSpecs$: Subject<string> = new Subject<string>();

  constructor() { }

  sendReset() {
    this._resetSpecs$.next('RESET');
  }

  get onReset(): Observable<string> {return this._resetSpecs$.asObservable();}

}
